interface Props {
  text?: string;
  vertical?: boolean;
}

import { cn } from '@/lib/utils';

import styles from './Divider.module.scss';

export const Divider = ({ text, vertical }: Props) => {
  return (
    <div className={cn(styles.lineWrapper, { [styles.vertical]: vertical })}>
      <div className={cn(styles.line, { [styles.vertical]: vertical })}>
        <span className={cn(styles.bar, { [styles.vertical]: vertical })}></span>
        {text && <span className={cn('text-sm leading-5 font-semibold', styles.text)}>{text}</span>}
        {!vertical && <span className={styles.bar}></span>}
      </div>
    </div>
  );
};
